// {display, type, value}
// THis file must be in sync with the one in batch job
export const TYPE_CARD_REF = "CARD_REF";
export const TYPE_INLINE = "INLINE_PLAIN";
export const TYPE_TERM = "TERM";
export const TYPE_HIGHLIGHT = "HIGHLIGHT";
export const TYPE_SUBTEXT = "SUBTEXT";
export const TYPE_BOLD = "BOLD";
export const TYPE_FLAVOR = "FLAVOR"